"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FromCodeToConcrete() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="535" id="from-code-to-concrete" className="relative w-full h-screen min-h-[600px] overflow-hidden text-foreground bg-background dark">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/consulting_web_design_software.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/consulting_web_design_software.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/consulting_web_design_software.png-wvc-sizes" alt="Professional consulting, web design, and software development services" className="w-full h-full object-cover" loading="eager" decoding="async" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/60" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 h-full w-full transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
        <div className="container mx-auto h-full px-6 sm:px-10 lg:px-16">
          <div className="flex h-full flex-col justify-end pb-16 sm:pb-20 lg:pb-24">
            <div className="max-w-4xl">
              {}
              <div className="flex items-center gap-4 mb-6 sm:mb-8">
                <span className="h-px w-12 sm:w-[60px] bg-primary" />
                <span className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.2em] sm:tracking-[0.25em] text-white/90 bg-black/40 backdrop-blur-sm px-3 py-1 rounded-md shadow-sm">
                  NYLA Tech · Est. MMXIV
                </span>
              </div>

              {}
              <h1 className="group font-default font-bold leading-[0.95] tracking-tight mb-6 sm:mb-8 text-white cursor-default" style={{
              fontSize: "clamp(3rem, 9vw, 8rem)"
            }}>
                <span className="block transition-all duration-500 group-hover:translate-x-4 group-hover:text-white/80">From Code to</span>
                <span className="block font-bold pl-8 sm:pl-16 lg:pl-24 text-primary transition-all duration-500 group-hover:translate-x-8 group-hover:brightness-110">
                  Concrete
                </span>
              </h1>

              {}
              <p className="font-default font-light text-lg sm:text-xl lg:text-2xl mb-8 sm:mb-12 max-w-xl text-white/90">
                We build and power businesses with construction excellence and technology solutions under one roof.
              </p>

              {}
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5 sm:gap-8">
                <Button asChild size="lg" className="h-12 px-8 rounded-md font-default text-xs uppercase tracking-[0.2em] shadow-md hover:shadow-lg transition-shadow bg-primary text-black hover:bg-primary/90">
                  <Link to="/HomePage">Our Services</Link>
                </Button>

                <Link to="/HomePage" className="group inline-flex items-center gap-2 font-default text-xs uppercase tracking-[0.2em] underline underline-offset-[6px] decoration-1 hover:decoration-2 transition-all text-white">
                  <span>Get a Quote</span>
                  <ArrowRight className="size-3.5 transition-transform group-hover:translate-x-1" />
                </Link>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="hidden md:flex absolute bottom-16 right-8 lg:right-12 flex-col items-center gap-4 z-20">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] whitespace-nowrap text-white" style={{
          writingMode: "vertical-rl",
          transform: "rotate(180deg)"
        }}>
            Scroll to Discover
          </span>
          <div className="relative w-px h-16 overflow-hidden bg-white/30">
            <div className="absolute top-0 left-0 w-full h-1/2 animate-[scrollPulse_2s_ease-in-out_infinite] bg-primary" />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scrollPulse {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
      `}</style>
    </section>;
}